module.exports = "<template>\n    <b-field class=\"file\">\n        <b-upload v-model=\"file\">\n            <a class=\"button is-primary\">\n                <b-icon icon=\"upload\"></b-icon>\n                <span>Click to upload</span>\n            </a>\n        </b-upload>\n        <span class=\"file-name\" v-if=\"file\">\n            {{ file.name }}\n        </span>\n    </b-field>\n    \n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                file: null\n            }\n        }\n    }\n</script>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./docs/pages/components/upload/examples/ExSimple.vue
// module id = 1575
// module chunks = 36